var $ = require('jquery')
var authService = require('../services/authenticationservice')
var User = require('../models/userprofilemodel')
var Global = require('./globalservice')
// var axios = require('axios')

var GET_TEAM_LEAD_URL = Global.HOST + 'api/user/getTeamLead'
var GET_USER_DETAIL_URL = Global.HOST + 'api/user/getUserDetail'
var GET_ALL_ROLE_URL = Global.HOST + 'api/role/getAllRole'
var GET_POST_CODE_URL = Global.HOST + 'api/postCode/getPostCode'
var CREATE_UPDATE_USER_URL = Global.HOST + 'api/user/createUpdateUserInfo'
var GET_ALL_GROUP_MANAGER = Global.HOST + 'api/user/getAllGroupManager'
var GET_GROUP_MANAGER = Global.HOST + 'api/user/getGroupManagerOfUser'
var GET_OT_APPROVER = Global.HOST + 'api/user/getShinseiOTApprover'
var GET_ADMIN = Global.HOST + 'api/user/getAllAdmin'
var DELETE_USER_URL = Global.HOST + 'api/user/delete'
var GET_ALL_CHANGE_PROFILE_REQUEST = Global.HOST + 'api/user/getAllChangeProfileRequest'
var APPROVE_USER_REQUEST = Global.HOST + 'api/user/approve'
var REJECT_USER_REQUEST = Global.HOST + 'api/user/reject'
var GET_REQUEST_BY_USER_AND_STATUS = Global.HOST + 'api/user/getRequestByUserAndStatus'

export default {
    getTeamLead: function (callback, error) {
      $.ajax({
        method: 'GET',
        url: GET_TEAM_LEAD_URL,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          callback(response.data)
        },
        error: function (err) {
          console.log(err)
        }
      })
    },

    getAllGroupManager: function (callback, error) {
      $.ajax({
        method: 'GET',
        url: GET_ALL_GROUP_MANAGER,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          callback(response.data)
        },
        error: function (err) {
          console.log(err)
        }
      })
    },

    getAllAdmin: function (callback, error) {
      $.ajax({
        method: 'GET',
        url: GET_ADMIN,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          callback(response.data)
        },
        error: function (err) {
          console.log(err)
        }
      })
    },

    

    getGroupManagerOfUser: function (callback, error) {
      $.ajax({
        method: 'GET',
        url: GET_GROUP_MANAGER,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          callback(response.data)
        },
        error: function (err) {
          console.log(err)
        }
      })
    },

    // get all GM and 委員長 who can accept OT request
    getShinseiOTApprover: function (callback, error) {
      $.ajax({
        method: 'GET',
        url: GET_OT_APPROVER,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          callback(response.data)
        },
        error: function (err) {
          console.log(err)
        }
      })
    },

    getUserDetail: function (id, callback, error) {
      $.ajax({
        method: 'GET',
        url: GET_USER_DETAIL_URL,
        data: {
          'id': id
        },
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          if (response.status === 'success') {
            var userProfile = new User.UserProfile(response.data)
            callback(userProfile)
          } else {
            error(response.message)
          }
        },
        error: function (err) {
          console.log(err)
        }
      })
    },

    getAllRole: function (callback, error) {
      $.ajax({
        method: 'GET',
        url: GET_ALL_ROLE_URL,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          if (response.status === 'success') {
            callback(response)
          } else {
            error(response.message)
          }
        },
        error: function (err) {
          console.log(err)
        }
      })
    },

    getPostCode: function (code, callback, error) {
      $.ajax({
        method: 'GET',
        url: GET_POST_CODE_URL + '/' + code,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          if (response.status === 'success') {
            callback(response.data)
          } else {
            error(response.message)
          }
        },
        error: function (err) {
          console.log(err)
        }
      })
    },

    createOrUpdateUserInfo: function (method, data, avatarFile, callback, error) {
      let file = new window.FormData()
      file.append('data', JSON.stringify(data))
      file.append('method', method)
      file.append('avatar', avatarFile)
      $.ajax({
        method: 'POST',
        url: CREATE_UPDATE_USER_URL,
        data: file,
        processData: false,
        contentType: false,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          if (response.status === 'success') {
            callback(response.data)
          } else {
            error(response.message)
          }
        },
        error: function (err) {
          error(err)
        }
      })
    },

    deleteUser: function (userId, callback, error) {
      $.ajax({
        method: 'POST',
        url: DELETE_USER_URL + '/' + userId,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          if (response.status === 'success') {
            callback(response.data)
          } else {
            error(response.message)
          }
        },
        error: function (err) {
          error(err)
        }
      })
    },

    getAllChangeProfileRequest: function (callback, error) {
      $.ajax({
        method: 'GET',
        url: GET_ALL_CHANGE_PROFILE_REQUEST,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          callback(response.data)
        },
        error: function (err) {
          console.log(err)
        }
      })
    },

    approveUserRequest: function (data, callback, error) {
      $.ajax({
        method: 'POST',
        url: APPROVE_USER_REQUEST,
        data: {
          data: JSON.stringify(data)
        },
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          if (response.status === 'success') {
            callback(response.data)
          } else {
            error(response)
          }
        },
        error: function (err) {
          console.log(err)
        }
      })
    },

    rejectUserRequest: function (data, callback, error) {
      $.ajax({
        method: 'POST',
        url: REJECT_USER_REQUEST,
        data: {
          data: JSON.stringify(data)
        },
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          if (response.status === 'success') {
            callback(response.data)
          } else {
            error(response)
          }
        },
        error: function (err) {
          console.log(err)
        }
      })
    },

    getRequestByUserAndStatus: function (data, callback, error) {
      $.ajax({
        method: 'POST',
        url: GET_REQUEST_BY_USER_AND_STATUS,
        data: {
          data: JSON.stringify(data)
        },
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          callback(response.data)
        },
        error: function (err) {
          console.log(err)
        }
      })
    },

    getUserProfile: function () {
      return JSON.parse(window.localStorage.getItem('user_profile'))
    },

    setUserProfile: function (userProfile) {
      window.localStorage.setItem('user_profile', JSON.stringify(userProfile))
    }
}



// WEBPACK FOOTER //
// ./client/services/userservice.js